<!-- =========================================================================================
  File Name: RequestIncidentSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>Request An Incident</h4>
        <!-- <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} SCHEDULE</h4> -->
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
     <div class="p-6">
        <vs-input  label="Name *" v-model="dataName" class="mt-5 w-full" name="name" v-validate="'required'" maxlength="150"/>
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span><br>
        <label class="vs-select--label w-full">Description *</label>
         <vs-textarea label="" v-model="dataDetails" v-validate="'required'" maxlength="190"/>
         <span ><small style="font-size:10px">Provide all relevant details about the incident, including date, start and stop time, and camera name for each video clip required to document the incident.</small></span><br><br>
        <label class="vs-select--label w-full">Location *</label>
        <ul class="centerx mt-2  flex flex-wrap">
         <li class="ml-1" v-for="location in locations" :key="location.id">
         <vs-radio v-model="dataLocation" @change=" getcamera(dataLocation)" :vs-value="location.id">{{location.name}}</vs-radio>
        </li>
        </ul>
        <h6 class="mt-6 flex items-center justify-between">Clips Required</h6><br>
        <div v-for="(clip,index) in clipRequest" :key="index">
          <span style="font-weight: bold"> Clip {{index+1}} <vs-button color="danger" size="small" @click.native="inputRemove(index)">Remove Clip</vs-button></span><br>
        <label class="vs-select--label w-full mt-5">Camera</label>
          <v-select :clearable="false" label="name" :closeOnSelect="true" v-model="clip.camera"  :options="cameras"/>
          <span  v-for="(time, timeindex) in clip.times" :key="timeindex">
            <label class="vs-select--label w-full ">Date &amp; Time *</label>
            <vs-row>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <datepicker class="w-full" v-model="time.date" format="MM/dd/yyyy" :minimumView="'day'"
                       placeholder="Date"    :maximumView="'year'" :initialView="'month'"></datepicker>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="end" vs-align="center" vs-w="4">
            <flat-pickr  class="mypicker" v-model="time.start_time" :config="configdateTimePicker" name="start_time" placeholder="Start time"/>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
            <flat-pickr class="mypicker" v-model="time.end_time" :config="configdateTimePicker" name="end_time" placeholder="End time"/>
            <span v-if="timeindex>0" class="danger" @click="inputRemoveTime(index,timeindex)" style="color:red">x</span>
            </vs-col>
            </vs-row>
            </span>
             <vs-row class="mt-1" >
              <vs-col class="flex">
              <vs-button class="ml-auto"  color="primary" size="small" @click.native="inputAddTime(index)"><feather-icon icon="PlusIcon" svgClasses="h-2 w-2"/></vs-button>
            </vs-col>
            </vs-row>
     </div>
     <vs-button color="primary" size="small" @click.native="inputAdd()">Add Another Clip</vs-button>
         </div>

    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import moment from 'moment'
import moduleDataList from '@/store/data-list/moduleDataList.js'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {
  ALL_LOCATIONS,
  REQUEST_INCIDENT,
  MANAGER_LOCATION,
  GET_CAMERA_BY_LOCATION
} from '@/graphql'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    flatPickr,
    moment
  },
  data () {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        timeFormat: 'H:i',
        time_24hr: false,
        altInput: true,
        dateFormat: 'H:i'
      },
      dataDetails:'',
      dataLocation:[],
      dataCamera:[],
      locations:[],
      cameras:[],
      dataName:'',
      requestedBy:'',
      clipRequest:[
        {
          camera:'',
          times: [
            {
              date:'',
              start_time: '',
              end_time: ''
            }
          ]
        }
      ]
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        // this.initValues()
        this.$validator.reset()
      } else {
        const {} = JSON.parse(JSON.stringify(this.data))
        // this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataName && this.dataDetails && this.dataLocation.length > 0 && this.dataCamera
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }

  },
  methods: {
    inputRemove (index) {
      this.clipRequest.splice(index, 1)
    },
    inputAdd () {
      this.clipRequest.push({
        camera:'',
        times:[
          {
            date:'',
            start_time: '',
            end_time: ''
          }
        ]
      })
    },
    inputAddTime (index) {
      this.clipRequest[index].times.push({
        start_time: '',
        end_time: ''
      })
    },
    inputRemoveTime (index, timeindex) {
      this.clipRequest[index].times.splice(timeindex, 1)
    },
    StatusSuccess () {
      this.$vs.notify({
        title: 'Incident',
        text: 'Incident requested successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    errorRequired (text) {
      this.$vs.notify({
        title: 'Incident',
        text,
        color: 'danger',
        position: 'top-right'
      })
    },
    submitData () {
      const  clipRequest = []
      for (let i = 0; i < this.clipRequest.length; i++) {
        const element = this.clipRequest[i]
        if (element['camera']) {
          for (let j = 0; j < element['times'].length; j++) {
            const time_element = element['times'][j]
            if (time_element['start_time'] != '' && time_element['end_time'] != '' && time_element['date'] != '') {
              time_element['date'] = moment(time_element['date']).format('MM/DD/YYYY')
              time_element['camera'] = element['camera'].id
              clipRequest.push(time_element)
            } else  {
              this.errorRequired('Date Times are Required')
              return
            }
          }
        } else {
          this.errorRequired('Camera Is Required!')
          return
        }
      }
      this.$validator.validateAll().then(result => {
        this.$apollo
          .mutate({
            mutation: REQUEST_INCIDENT,
            variables: {
              name:this.dataName,
              details:this.dataDetails,
              status:'Requested',
              location: this.dataLocation,
              requested_by:this.requestedBy,
              times:clipRequest
            }
          })
          .then(response => {
            if (response.data.requestIncident.status == 'SUCCESS') {
              this.StatusSuccess()
              this.$emit('closeSidebar')
              this.initValues()
            }
          }).catch(error => {
            console.log(error)

          })


      })
    },

    initValues () {
      this.requestedBy = ''
      this.dataName = ''
      this.dataDetails = ''
      this.dataLocation = []
      this.dataCamera = []
      this.cameras = []
      this.clipRequest=[
        {
          camera:'',
          times: [
            {
              date:'',
              start_time: '',
              end_time: ''
            }
          ]
        }
      ]
    },
    getcamera (location) {
      for (let index = 0; index < this.clipRequest.length; index++) {
        this.clipRequest[index].camera = ''
      }
      this.$apollo
        .mutate({
          mutation: GET_CAMERA_BY_LOCATION,
          variables: {
            location_id:location
          }
        })
        .then(response => {
          if (response) {
            this.cameras = response.data.location_cameras
          }
        }).catch(error => {
          console.log(error)
        })
    },
    conditionMethod (role, id) {
      if (role == 'manager') {
        this.$apollo
          .mutate({
            mutation: MANAGER_LOCATION,
            variables: {
              id
            }
          })
          .then(response => {
            console.log(response)
            this.locations = response.data.user.managerlocations
          }).catch(error => {
            console.log(error)
          })
      }
      if (role == 'admin' || role == 'center') {
        this.$apollo
          .mutate({
            mutation: ALL_LOCATIONS
          })
          .then(response => {
            this.locations = response.data.locations

          })
      }
    }
  },
  created () {
      let userId= localStorage.getItem('userId');
      let userRole = JSON.parse(localStorage.getItem('userRoles'))
      userRole = userRole[0].name
      this.requestedBy = userId
      this.conditionMethod(userRole,userId)
  }
}
</script>
<style >
.mypicker{
  width: 120px;
}
</style>
<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }

}


</style>
